import { createBrowserRouter } from 'react-router-dom'

import { assemblyRoutes } from './assembly/routes'
import ErrorPage from './error/Error.page'
import { MainLayout } from './Main.layout'
import { shipmentRoutes } from './shipment/routes'
import { utilsRoutes } from './utils/routes'

export const router = createBrowserRouter([
  {
    element: <MainLayout />,
    errorElement: <ErrorPage />,
    children: [...assemblyRoutes, ...shipmentRoutes, ...utilsRoutes]
  }
])
